import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import DOMPurify from 'dompurify';
import api from '@/lib/api';

export default function Privacy() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/public/settings').then(res => {
      setSettings(res.data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-32 flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Caricamento...</div>
      </div>
    );
  }

  return (
    <div className="pt-32 pb-24" data-testid="privacy-page">
      {/* Header */}
      <div className="max-w-3xl mx-auto px-6 lg:px-12 mb-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl mb-6">Privacy Policy</h1>
        </motion.div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="prose prose-lg max-w-none"
        >
          {settings?.privacy_policy ? (
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(settings.privacy_policy) }} />
          ) : (
            <>
              <h2>Informativa sulla Privacy</h2>
              <p>
                La presente informativa descrive le modalità di gestione del sito in riferimento al trattamento 
                dei dati personali degli utenti che lo consultano.
              </p>

              <h3>Titolare del Trattamento</h3>
              <p>
                Il titolare del trattamento dei dati è Andrea Caruso, contattabile all'indirizzo email 
                indicato nella sezione Contatti del sito.
              </p>

              <h3>Dati Raccolti</h3>
              <p>
                I dati personali raccolti attraverso il sito includono:
              </p>
              <ul>
                <li>Dati di navigazione (indirizzi IP, orari di accesso, pagine visitate)</li>
                <li>Dati forniti volontariamente (nome, email, telefono) tramite i form di contatto e prenotazione</li>
              </ul>

              <h3>Finalità del Trattamento</h3>
              <p>
                I dati sono trattati per le seguenti finalità:
              </p>
              <ul>
                <li>Rispondere alle richieste di informazioni e preventivi</li>
                <li>Gestire le prenotazioni dei servizi</li>
                <li>Migliorare l'esperienza di navigazione sul sito</li>
              </ul>

              <h3>Diritti dell'Interessato</h3>
              <p>
                L'utente ha diritto di accedere ai propri dati, richiederne la rettifica o la cancellazione, 
                e opporsi al loro trattamento contattando il titolare.
              </p>

              <h3>Cookie</h3>
              <p>
                Il sito utilizza cookie tecnici necessari al funzionamento. Per maggiori informazioni, 
                consultare la Cookie Policy.
              </p>
            </>
          )}
        </motion.div>
      </div>
    </div>
  );
}
